const COPY_BUTTON_NAME = 'copy-button';
const COPY_INFO_TEXT = 'Copy Url';
const COPY_SUCCESS_TEXT = 'Url copied';
const COPY_ERROR_TEXT = 'Unable to copy Url';

class CopyButton extends HTMLButtonElement {
    constructor() {
        super();

        this._alertAnim = null;
        this._copyValue = this._copyValue.bind(this);
        this._addAlertEls = this._addAlertEls.bind(this);
        this._triggerAlert = this._triggerAlert.bind(this);
    }

    connectedCallback() {
        if (this.value === undefined || this.value.length === 0) {
            console.error(`Custom element <${COPY_BUTTON_NAME}> required a valid value attribute to copy.`);
        } else {
            this._interactionAnim = this.getAnimations({ subtree: true }).find((anim) => anim.animationName === 'interaction-anim');
            this._addAlertEls();

            this.addEventListener('click', this._copyValue);
        }
    }

    disconnectedCallback() {
        this.removeEventListener('click', this._copyValue);
    }

    _addAlertEls() {
        this._alertEl = this._createAlertEl(COPY_SUCCESS_TEXT, `${COPY_BUTTON_NAME}__alert`);

        let docFrag = document.createDocumentFragment();
        docFrag.append(this._alertEl);

        const mutationObserver = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList' && this._alertAnim === null) {
                    this._alertAnim = this._alertEl.getAnimations()?.find((anim) => anim.animationName === 'copy-alert');
                    this._alertAnim.onfinish = () => {
                        this._alertEl.removeAttribute('role'); // Used for resetting accessible alert for screen readers
                    };
                }
            }
        });

        mutationObserver.observe(this, { attributes: false, childList: true, subtree: false });
        this.append(docFrag);
    }

    _copyValue(event) {
        event.preventDefault();

        navigator.clipboard
            .writeText(this.value)
            .then(() => {
                if (this._interactionAnim !== null) {
                    this._interactionAnim.startTime = 0;
                    this._interactionAnim.play();
                }

                this._triggerAlert(`<strong>${this.value}</strong> <span class="sr-only">has been</span>copied to clipboard`);
            })
            .catch(() => {
                this._triggerAlert(COPY_ERROR_TEXT);
                console.error('failed to copy.');
            });
    }

    _triggerAlert(message) {
        if (this._alertAnim !== null) {
            this._alertEl.innerHTML = message;
            this._alertEl.setAttribute('role', 'alert');
            this._alertAnim.startTime = 0;
            this._alertAnim.play();
        }
    }

    _createAlertEl(copy, cssClass) {
        const el = document.createElement('p');
        el.innerText = copy;
        el.className = cssClass;
        return el;
    }
}

customElements.define(COPY_BUTTON_NAME, CopyButton, { extends: 'button' });
